import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EntityOrderedRequestParameters} from '@bndes/bndes-ux4/bndes-angular-utils';
import Utils from '../../../shared/fgi-utils';
import {ModalidadeScrModel, ObjetivoFinanciamento, ObjetivoFinanciamentoLista} from '../../../model/modalidade-scr.model';

@Component({
  selector: 'app-modalidade-scr-listagem',
  templateUrl: 'modalidade-scr-listagem.html',
  standalone: false
})
export class ModalidadeScrListagem implements OnInit {

  @Input() public modalidadesNoScr: ModalidadeScrModel[] = [];
  @Output() public atualizarListagem: EventEmitter<any> = new EventEmitter<any>();

  public listaTipos: ObjetivoFinanciamento[] = ObjetivoFinanciamentoLista;
  public atributosOrdenacao: EntityOrderedRequestParameters;
  @Output() desabilitarCodigoModalidade: EventEmitter<number> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    };
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacaoConsulta(this.atributosOrdenacao);
  }

  pesquisarOrdenacaoConsulta(ord: EntityOrderedRequestParameters) {
    let func = undefined;
    if (ord.atributo == 'valor') {
      func = parseFloat;
    }
    this.modalidadesNoScr = this.modalidadesNoScr.sort((a, b) => {
      if (ord.sentido == 'asc') {
        return Utils.comparaComFuncao(a, b, ord.atributo, func);
      } else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, func);
      }
    });
  }

  labelTipo(valor: string) {
    switch (valor) {
      case 'GIRO':
        return this.listaTipos.filter(item => item.valor == 'G').length > 0 ?
          this.listaTipos.filter(item => item.valor == 'G')[0].nome : '';

      case 'INVESTIMENTO':
        return this.listaTipos.filter(item => item.valor == 'I').length > 0 ?
          this.listaTipos.filter(item => item.valor == 'I')[0].nome : '';
    }
  }

  confirmaExclusao(codigo: number) {
    this.desabilitarCodigoModalidade.emit(codigo);
  }

}
